export default __webpack_public_path__ + "static/media/restart.423479f4.svg";